import { Deserializable } from '../../protocols/deserializable';
import { MapUtils } from '../../../utils/map.utils';

export class VariantFeature implements Deserializable {
  public title: string;
  public variantIds: string[];
  public descriptionOverrideMap: Map<string, string>;
  public priceOverrideMap: Map<string, number>;
  public assetNameMap: Map<string, string>;

  public onDeserialize() {
    this.variantIds = Array.from(this.variantIds || []);
    if (!(this.descriptionOverrideMap instanceof Map)) {
      this.descriptionOverrideMap = window.injector.Deserialize.genericMap(this.descriptionOverrideMap);
    }
    if (!(this.priceOverrideMap instanceof Map)) {
      this.priceOverrideMap = window.injector.Deserialize.genericMap(this.priceOverrideMap);
    }
    if (!(this.assetNameMap instanceof Map)) {
      this.assetNameMap = window.injector.Deserialize.genericMap(this.assetNameMap);
    }
  }

  public removeId(id: string) {
    this.priceOverrideMap?.delete(id);
    this.descriptionOverrideMap?.delete(id);
    this.assetNameMap?.delete(id);
  }

  public hasChanges(v: VariantFeature): boolean {
    return (
      !v ||
      this.title !== v.title ||
      !this.variantIds.equals(v.variantIds) ||
      !MapUtils.equals(this.descriptionOverrideMap, v.descriptionOverrideMap) ||
      !MapUtils.equals(this.assetNameMap, v.assetNameMap) ||
      !MapUtils.equals(this.priceOverrideMap, v.priceOverrideMap)
    );
  }
}
